/**
 * Trigger a client-side file download for in-memory text content.
 *
 * Centralized here so every CSV uploader (listings, and future ones) shares one
 * implementation for "download this string as a file" — e.g. template
 * downloads, error-row exports — instead of re-implementing the Blob + anchor
 * dance in each dialog.
 */
export function downloadTextFile(
  filename: string,
  content: string,
  mimeType = 'text/csv',
): void {
  const blob = new Blob([content], { type: mimeType })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.click()
  URL.revokeObjectURL(url)
}
